// extracted by mini-css-extract-plugin
export var cardIcon = "_8p-5";
export var cardIconUnframed = "_8p-9";
export var checkboxCard = "_8p-0";
export var checkboxCardSelected = "_8p-4";
export var disabled = "_8p-2";
export var interactive = "_8p-1";
export var outerBorder = "_8p-3";
export var spacerMedium = "_8p-8";
export var spacerSmall = "_8p-7";
export var spacerXsmall = "_8p-6";